// extracted by mini-css-extract-plugin
export default {"button":"styles_button__UYuMm","friendInfoWrapper":"styles_friendInfoWrapper__Y+JXw","textInfo":"styles_textInfo__7Zc0n"};